module.exports = __webpack_public_path__ + "static/item--chloe--f7@3x.07341e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f7@3x.png
// module id = 641
// module chunks = 126511778744290